
export default function Services() {
  const services = [
    {
      icon: 'ri-user-heart-line',
      title: 'Psicoterapia Individual',
      description: 'Atendimento personalizado e confidencial, focado nas necessidades específicas de cada paciente. Um espaço seguro para autoconhecimento, elaboração de questões emocionais e desenvolvimento de estratégias para uma vida mais equilibrada.',
      features: ['Sessões de 50 minutos', 'Atendimento presencial ou online', 'Sigilo profissional garantido']
    },
    {
      icon: 'ri-group-line',
      title: 'Psicoterapia em Grupo',
      description: 'Trabalho terapêutico em grupo, proporcionando um ambiente de apoio mútuo e troca de experiências. Ideal para questões que se beneficiam da interação social e do compartilhamento de vivências semelhantes.',
      features: ['Grupos temáticos', 'Ambiente acolhedor', 'Aprendizado coletivo']
    },
    {
      icon: 'ri-presentation-line',
      title: 'Palestras',
      description: 'Palestras e workshops sobre saúde mental, bem-estar emocional e qualidade de vida para empresas, escolas e instituições. Conteúdo baseado em evidências científicas com linguagem acessível e prática.',
      features: ['Temas personalizados', 'Formato presencial ou online', 'Material de apoio']
    },
    {
      icon: 'ri-heart-add-line',
      title: 'Atendimentos em Saúde Emocional',
      description: 'Acompanhamento especializado para questões relacionadas ao bem-estar emocional, prevenção de transtornos mentais e promoção de saúde mental. Foco no desenvolvimento de habilidades emocionais e resiliência.',
      features: ['Abordagem preventiva', 'Técnicas de autocuidado', 'Orientação profissional']
    }
  ];

  return (
    <section id="servicos" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-light text-gray-800 mb-4">
            Serviços
          </h2>
          <div className="w-16 h-1 bg-[#B8E6D5] mx-auto mb-6"></div>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            Atendimento psicológico com ética, sigilo e cuidado humanizado. Cada serviço é desenvolvido com responsabilidade e comprometimento com o seu bem-estar emocional.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-[#FAFAFA] p-8 rounded-xl hover:shadow-lg transition-all duration-300 group"
            >
              <div className="flex items-start gap-5 mb-5">
                <div className="w-14 h-14 flex items-center justify-center bg-white rounded-full shadow-sm group-hover:scale-110 transition-transform duration-300 flex-shrink-0">
                  <i className={`${service.icon} text-2xl text-[#A8D5E2]`}></i>
                </div>
                <div>
                  <h3 className="text-xl font-medium text-gray-800 mb-2">
                    {service.title}
                  </h3>
                </div>
              </div>
              
              <p className="text-sm text-gray-700 leading-relaxed mb-5">
                {service.description}
              </p>

              <div className="space-y-2">
                {service.features.map((feature, idx) => (
                  <div key={idx} className="flex items-center gap-2">
                    <i className="ri-check-line text-[#B8E6D5] text-lg"></i>
                    <span className="text-sm text-gray-600">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-gradient-to-r from-[#A8D5E2]/10 to-[#F4C2C2]/10 p-8 rounded-xl text-center">
          <p className="text-base text-gray-700 leading-relaxed max-w-3xl mx-auto">
            <strong className="font-medium">Compromisso com a ética e o sigilo:</strong> Todos os atendimentos seguem rigorosamente o Código de Ética Profissional do Psicólogo, garantindo confidencialidade, respeito e cuidado humanizado em cada sessão.
          </p>
        </div>
      </div>
    </section>
  );
}
